import { useMediaQuery } from 'react-responsive';

import { Recipe } from '../../../../type';
import { GRAY_COLOR_200, MAX_WIDTH_639PX } from '../../../../utils/common';
import Slide from '../../Slide';
import RecommendRecipeCard from '../RecommendRecipeCard';

const SLIDE_TRANSITION_DURATION = 400; // 다음 슬라이드로 넘어가는 트랜지션 시간

interface OriginalRecipeCurationSlideProps {
  thisWeekVegetables: string[];
  recipes: Recipe[];
  curationTitle: string;
}
const OriginalRecipeCurationSlide = ({
  thisWeekVegetables,
  recipes,
  curationTitle,
}: OriginalRecipeCurationSlideProps) => {
  const isMobile = useMediaQuery({ query: MAX_WIDTH_639PX });

  const defaultIndexClass =
    'text-16px flex-grow cursor-pointer py-16px text-center font-medium';

  const getBorderStyle = (index: number) => {
    return isMobile
      ? {
          borderRight: !Boolean(index % 2)
            ? `1px solid ${GRAY_COLOR_200}`
            : 'unset',
          borderBottom:
            index < recipes.length - 2
              ? `1px solid ${GRAY_COLOR_200}`
              : 'unset',
        }
      : {
          borderRight:
            index !== recipes.length - 1
              ? `1px solid ${GRAY_COLOR_200}`
              : 'unset',
        };
  };

  return (
    <Slide
      contents={recipes}
      renderSlide={(content, i) => (
        <RecommendRecipeCard
          key={i}
          recipe={content as Recipe}
          thisWeekVegetables={thisWeekVegetables}
          disabledTransformWrapper
          onClick={() => {}}
        />
      )}
      showIndex
      renderIndex={(content) => <>{content.name}</>}
      activeIndexClass={`${defaultIndexClass} font-normal bg-gray-100`}
      inactiveIndexClass={`${defaultIndexClass} text-gray-600`}
      indexContainerClass={
        isMobile
          ? 'grid grid-cols-2 rounded-10px border border-gray-200'
          : 'flex rounded-sm border border-gray-200'
      }
      indexContainerStyle={{ marginTop: 8 }}
      indexListStyle={(index) => getBorderStyle(index ?? 0)}
      slideTransitionDuration={SLIDE_TRANSITION_DURATION}
    />
  );
};

export default OriginalRecipeCurationSlide;
